<form [formGroup]="formGroup" autocomplete="off" *ngIf="formGroup">
  <maporium-title-description (fieldsChange)="onNameDescriptionChange($event)"
                              (titleInputChange)="onInstantNameChange($event)"
                              (nameFieldFocus)="onNameFieldFocus()"
                              (nameFieldBlur)="onNameFieldBlur()"
                              (descriptionFieldFocus)="onDescriptionFieldFocus()"
                              (descriptionFieldBlur)="onDescriptionFieldBlur()"
                              [isNew]="focusedNode?.isNew || false"
                              [entityId]="focusedNode?.id"
                              [fields]="{title: formGroup.get('name')?.value || '', description: formGroup.get('description')?.value || ''}"
                              [isEditing]="true"></maporium-title-description>
  <div class="mt-3">
    <cdk-accordion [multi]="true" class="accordion">
      <maporium-accordion-item [sections]="visibleMetaCount"
                               [iconClass]="'icon-smap-object-property'"
                               tourAnchor="properties-anchor"
                               [title]="'MAP_INFO.PROPERTIES' | translate">
        <maporium-meta-data-control (extendMeta)="metaExtend.emit()"
                                    formControlName="metadata"></maporium-meta-data-control>
      </maporium-accordion-item>
      <ng-container *appHasPackage="[PACKAGE_NAMES.developer]">
        <maporium-accordion-item [iconClass]="'icon-smap-object-property'"
                                 [sections]="hasBottleneckMark ? 1 : 0"
                                 [title]="'SHARED_FORMS.BOTTLENECK' | translate">
          <maporium-bottleneck-marker [metadata]="focusedNode?.metadata"
                                      (metadataChange)="onBottleneckChange($event)"></maporium-bottleneck-marker>
        </maporium-accordion-item>
      </ng-container>
      <maporium-accordion-item *hasMapPermission="'comment'"
                               [iconClass]="'icon-smap-object-comment'"
                               [sections]="commentsCount"
                               [title]="'MAP_INFO.COMMENTS' | translate">
        <maporium-comments (updated)="this.focusedNode!.hasComments = $event"
                           (commentCount)="commentsCount = $event"
                           [entityId]="focusedNode!.id"
                           [entityType]="'node'"
                           [isEditing]="!isDefaulter">
        </maporium-comments>
      </maporium-accordion-item>
      @if (isInIframe() && currentMap.hasGuestComments) {
        <maporium-accordion-item [sections]="commentsCount"
                                 [iconClass]="'icon-smap-object-comment'"
                                 [title]="'MAP_INFO.COMMENTS' | translate">
          <maporium-comments (updated)="this.focusedNode!.hasComments = $event"
                             (commentCount)="commentsCount = $event"
                             [entityId]="focusedNode!.id"
                             [entityType]="'node'">
          </maporium-comments>
        </maporium-accordion-item>
      }
      <maporium-accordion-item [sections]="sectionsCount"
                               [iconClass]="'icon-smap-object-style'"
                               [title]="'MAP_INFO.STYLES.TITLE' | translate">
        <maporium-node-style [focusedNode]="focusedNode" [formGroup]="formGroup"></maporium-node-style>
      </maporium-accordion-item>

      @if (!isDefaultState) {
        <maporium-accordion-item
          [iconClass]="'icon-smap-object-state-custom'"
          [title]="'STATES.TITLE' | translate" >
          <app-select-input formControlName="excludedFromState"
                            class="mb-1"
                            [label]="'unknown_2'"
                            [isIcon]="true"

                            [options]="excludeFromStateOptions"
                            [placeholder]="'NODES.NODE_INCLUSION' | translate">
          </app-select-input>
          <div class="d-flex mt-2 justify-content-center no-gutter">
            <button class="reset-button"
                    mat-flat-button
                    (click)="resetState()">{{ 'STATES.REVERT_TO_BASE' | translate }}
            </button>
          </div>
        </maporium-accordion-item>
      }
    </cdk-accordion>
  </div>
</form>
